import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import SOLogout from "../../components/Logout/SOLogout";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, useNavigate } from "react-router-dom";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import "jspdf-autotable";
import Excel from "../../assets/img/excel.png";
import PDF from "../../assets/img/pdf1.png";

import { dealerGetListDsrTransaction } from "../../redux/actions/dealerGetListDsrTransactionAction";
import { getTransactionTypeListDetails } from "../../redux/actions/getTransactionTypeListAction";
import { dealerDsrTransactionExcelPdfFiles } from '../../redux/actions/dealerDsrTransactionExcelPdfFileAction'
import Layout from "../../components/Wrappers/Layout";
import { getKycReportList } from "../../redux/actions/getKycReportListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation/index";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
function DealerDsrTransaction() {
	const csv = "1";
	const pdf = "0";
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getDsrTransactionListStatus, setGetDsrTransactionListStatus] =
		useState(false);
	const [getDsrTransactionListArray, setGetDsrTransactionListArray] = useState(
		[]
	);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);
	const [getTransactionTypeListStatus, setGetTransactionTypeListStatus] =
		useState(false);

	const [getDsrTransactionExcelPdfFileResStatus, setGetDsrTransactionExcelPdfFileResStatus] =
		useState(false)

	const [getTranactionId, setTransactionId] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const [isFee, setIsFee] = useState("");
	const [getTransactionAmount, setGetTransactionAmount] = useState("");
	const [getDsrContact, setGetDsrContact] = useState("");
	const [getCustomerContact, setGetCustomerContact] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [transactionSubType, setTransactionSubType] = useState("");
	const [getFromCustomerId, setGetFromCustomerId] = useState("")


	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const handleDateChange = (date) => {
		setSelectedDate(date);
	};
	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getDsrTransactionList = useSelector(
		({ dealerGetListDsrTransactionLists }) => dealerGetListDsrTransactionLists
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getDsrTransactionExcelPdfFileRes = useSelector(
		({ dealerDsrTransactionExcelPdfDataLists }) => dealerDsrTransactionExcelPdfDataLists
	);

	const dispatch = useDispatch();
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();

	//   dealerGetListDsrTransactionTypeLists

	// const [user, setUser] = useState({
	//     transactionId: "",
	//     // walletOwnerId: "",
	//     transactionType: "All",
	//     transactionAmount: "",
	//     dsrContact: "",
	//     toCustomerContact: "",
	//     currency: "",
	//     isFee: ""
	// });
	// const {
	//     transactionId,
	//     walletOwnerId,
	//     transactionType,
	//     transactionAmount,
	//     dsrContact,
	//     toCustomerContact,
	//     currency,
	//     isFee
	// } = user;
	// const onInputChange = ({ target: { name, value } }, type) => {
	//     const obj = {
	//         ...user,
	//     };
	//     if (type == "number") {
	//         obj[name] = Util.verifyMobile(value) ? value : obj[name];
	//     } else if (type == "alphabet") {
	//         obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
	//     } else if (type == "both") {
	//         obj[name] = Util.alphaNumeric(value) ? value : obj[name];
	//     } else {
	//         // obj[name] = value.trim()
	//         obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
	//     }
	//     setUser(obj);
	// }
	const handleChange = ({ target: { name, value } }) => {
		if (name === "transactionId") {
			// setTransactionId(value);
			Util.verifyNumber(value)
				? setTransactionId(value)
				: setTransactionId(getTranactionId);
		}
		// if (name === "transactionType") {
		//     setTransactionType(value == "Select Transaction Type" ? "" : value);

		// }
		if (name === "transactionType") {
			setTransactionType(value == "Select Transaction Type" ? "" : value);
			// setTransactionType(value);
		}
		if (name === "transactionAmount") {
			Util.verifyNumber(value)
				? setGetTransactionAmount(value)
				: setGetTransactionAmount(getTransactionAmount);
		}
		if (name === "DSRContact") {
			setGetDsrContact(value);
		}
		if (name === "ToCustomerContact") {
			setGetCustomerContact(value);
		}
		if (name === "Currency") {
			setEditCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "IsFee") {
			setIsFee(value == "All" ? "" : value);
		}
	};
	// const getTransactionTypeList = () => {
	//     if (getTransactionTypeListRes.data.status == "success") {
	//         setGetTransactionTypeListResArray(
	//             getTransactionTypeListRes.data.transactionType
	//         );
	//     }
	// };
	// useEffect(() => {
	//     getTransactionTypeList();
	// }, []);
	const getDealerExcelPdfFileListReq = (csvOrPdf) => {
		// setIsLoading(true);
		setGetDsrTransactionExcelPdfFileResStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				action: "csv",
				fromCustId: getFromCustomerId,
				fdtstamp: moment(selectedDate).format("YYYY-MM-DD"),
				tdtstamp: moment(selectedToDate).format("YYYY-MM-DD"),
				currency: "BDT",
				transactionType: transactionType,
				transactionSubType: transactionSubType,
				reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
				// transactionId: getTranactionId,
				// isFee: isFee,
			}
		};
		dispatch(dealerDsrTransactionExcelPdfFiles(req, authToken));
	}

	useEffect(() => {
		if (getDsrTransactionExcelPdfFileResStatus) {
			if (getDsrTransactionExcelPdfFileRes.data.status == "success") {
				var link = document.createElement("a");
				link.download = getDsrTransactionExcelPdfFileRes.data.fileName;
				link.href =
					"data:application/octet-stream;base64," +
					getDsrTransactionExcelPdfFileRes.data.fileDate.split(`,`)[1];
				link.click();
			}
		}
	}, [getDsrTransactionExcelPdfFileRes.data.status]);

	useEffect(() => {
		if (getDsrTransactionExcelPdfFileRes.data.status == "success") {
			setPage(0);
		}
	}, [getDsrTransactionExcelPdfFileRes.data.status]);


	const getTransactionTypeListReqApi = () => {
		setGetTransactionTypeListStatus(true);
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};

		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, authToken)
		);
	};

	const GetTransactionTypeListFunc = () => {
		if (getTransactionTypeListStatus) {
			if (getTransactionTypeListRes.data.status == "success") {
				setGetTransactionTypeListResArray(
					getTransactionTypeListRes.data.transactionType
				);
			}
			if (getTransactionTypeListRes.data.status == "failed") {
				setGetTransactionTypeListResArray(getTransactionTypeListRes.data);
				if (
					getTransactionTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		GetTransactionTypeListFunc();
	}, [getTransactionTypeListRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getTransactionTypeListReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getDealerDsrTransactionListReq = () => {
		setIsLoading(true);
		setGetDsrTransactionListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				fdtstamp: moment(selectedDate).format("YYYY-MM-DD"),
				tdtstamp: moment(selectedToDate).format("YYYY-MM-DD"),
				transactionId: getTranactionId,
				transactionType: transactionType,
				// transactionType == "All" ? "" : transactionType,
				isFee: isFee,
				transactionAmount: getTransactionAmount,
				dsrContact: getDsrContact,
				customerContact: getCustomerContact,
				// currency: editCurrency == "All" ? "" : editCurrency,
				currency: editCurrency
			}
		};
		dispatch(dealerGetListDsrTransaction(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getDealerDsrTransactionListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getDsrTransactionListResFunc = () => {
		if (getDsrTransactionListStatus) {
			if (getDsrTransactionList.data.status == "success") {
				setIsLoading(false);
				setGetDsrTransactionListArray(
					[].concat(getDsrTransactionList.data.dsrTransactionList)
				);
			}
			if (getDsrTransactionList.data.status == "failed") {
				setIsLoading(false);
				setGetDsrTransactionListArray(getDsrTransactionList.data);
				if (
					getDsrTransactionList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getDsrTransactionList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getDsrTransactionList.data.status == "Not Found") {
				setIsLoading(false);
				setGetDsrTransactionListArray(getDsrTransactionList.data);
			}
		}
	};

	useEffect(() => {
		getDsrTransactionListResFunc();
	}, [getDsrTransactionList.data.status]);

	useEffect(() => {
		if (getDsrTransactionList.data.status == "success") {
			setPage(0);
		}
	}, [getDsrTransactionList.data.status]);
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};
	// const getDsrMasterListReq = () => {
	//     // setIsLoading(true);

	//     setGetDsrTransactionListStatus(true)
	//     const req = {
	//         actionCustomerMasterRequestVO: {
	//             dealerId: partnerloginUser.data.partnerId,
	//             walletOwnerId: transactionId,

	//             dsrtransactionType: transactionType,
	//             dsrtransactionAmount: transactionAmount,
	//             dsrContact: dsrContact,
	//             dsrtoCustomerContact: toCustomerContact,
	//             dsrcurrency: currency,
	//             dsrisFee: isFee
	//         }
	//     }
	//     dispatch(dealerGetListDsrTransaction(req, authToken))
	// }
	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										// format="MM/dd/yyyy"
										format="yyyy/MM/dd"

										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										// format="MM/dd/yyyy"
										format="yyyy/MM/dd"

										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="Transaction ID"
								fullWidth={true}
								name="transactionId"
								value={getTranactionId}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="name"
								fullWidth
								name="transactionType"
								value={transactionType || ""}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Transaction Type"
									selected="Select Transaction Type"
								>
									Select Transaction Type
								</MenuItem>
								{getTransactionTypeListRes.success &&
									getTransactionTypeListRes.data.transactionType.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="Transaction Amount"
								fullWidth={true}
								name="transactionAmount"
								value={getTransactionAmount}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="DSR Contact"
								fullWidth={true}
								name="DSRContact"
								value={getDsrContact}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								// required
								size="small"
								color="primary"
								type="text"
								label="To Customer Contact"
								fullWidth={true}
								name="ToCustomerContact"
								value={getCustomerContact}
								onChange={handleChange}
								// onChange={onInputChange}
								// onChange={(e) => onInputChange(e, "number")}
								style={{ marginTop: "3px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								margin="dense"
								label="Currency"
								fullWidth
								name="Currency"
								// value={"Select Currency" || editCurrency}
								defaultValue={"Select Currency" || editCurrency}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								<MenuItem value="BDT">BDT</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								style={{ marginTop: "3px" }}
								select
								autoFocus
								// margin="dense"

								label="Is Fee"
								fullWidth
								name="IsFee"
								defaultValue={isFee || "All"}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={3} lg={3}>
							{/* <Button
                                style={{
                                    backgroundColor: "#00b9f5",
                                    color: "white",
                                    marginTop: "16px",
                                }}
                                endIcon={<AiOutlineSearch />}
                                variant="contained"
                                onClick={getDsrMasterListReq}
                            >
                                Search
                            </Button> */}
							<CustomButton
								style={{
									padding: "8px",
									margin: "15px 8px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getDealerDsrTransactionListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>
				{isLoading ? (
					<LoadingSpinner />
				) : getDsrTransactionListArray.length == undefined ||
					!getDsrTransactionListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<Grid
									container
									style={{
										padding: "10px",
										textAlign: "center",
										justifyContent: "right"
									}}
								>
									<Grid
										container
										style={{
											padding: "10px",
											textAlign: "center",
											justifyContent: "right",
											gap: "10px"
										}}
									>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={Excel}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getDealerExcelPdfFileListReq(csv)
												}}
											></img>
										</Grid>
										<Grid item xs={4} sm={4} md={1} lg={1}>

											<img
												src={PDF}
												style={{ height: "30px", cursor: "pointer" }}
												onClick={() => {
													getDealerExcelPdfFileListReq(pdf)
												}}
											></img>
										</Grid>
									</Grid>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction date
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction amount{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Dsr Contact
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													To customer
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													To Customer Contact
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Remark
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getDsrTransactionListArray &&
												[]
													.concat(getDsrTransactionListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.fromDate}
															</TableCell>
															<TableCell align="center">
																{row.transactionId}
															</TableCell>

															<TableCell align="center">
																{row.transactionType}
															</TableCell>
															<TableCell align="center">
																{row.transactionAmount}
															</TableCell>
															<TableCell align="center">
																{row.dsrMob}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerName}
															</TableCell>
															<TableCell align="center">
																{row.toCustomerContact}
															</TableCell>
															<TableCell align="center">
																{row.transactionStatus}
															</TableCell>
															<TableCell align="center">{row.remark}</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getDsrTransactionListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
		</>
	);
}

export default DealerDsrTransaction;
